/* eslint-disable */
// Lens search helpers (Brief D). `lensHaystack` = a null-safe, lowercased, every-field string for
// the boolean substring test (family inline filter). `lensMatch` returns the FIRST field that
// matched + its value for the all-lenses result tag (name/lens_no matches set skip=true so the
// row shows no tag). Both cover: lens_no, raw_name, color, nickname, supplier_code, dev_code,
// supplier, coating, mirror_effect, gradient_type, notes, family (label), and category (as "1"
// and "cat.1"). `lensHaystack` is memoized per lens object (WeakMap) since rows are stable.
import { familyMeta } from './lensFamilies';

// [key, tagLabel, skipTag] — order = "first match" priority for the tag
const FIELDS = [
  ['lens_no', 'lens no', true], ['legacy_no', 'legacy'], ['raw_name', 'name', true], ['color', 'color'],
  ['nickname', 'nickname'], ['supplier_code', 'supplier code'], ['dev_code', 'dev code'],
  ['supplier', 'supplier'], ['coating', 'coating'], ['mirror_effect', 'mirror'],
  ['gradient_type', 'gradient'], ['notes', 'notes'],
];

const _cache = new WeakMap();
export function lensHaystack(lens) {
  if (!lens || typeof lens !== 'object') return '';
  if (_cache.has(lens)) return _cache.get(lens);
  const parts = FIELDS.map(([k]) => lens[k] || '');
  if (lens.category != null && lens.category !== '') parts.push(String(lens.category), `cat.${lens.category}`);
  parts.push(familyMeta(lens.family).label || '', lens.family || '');
  const s = parts.join(' ').toLowerCase();
  _cache.set(lens, s);
  return s;
}

// First-matching field for the all-lenses result tag; null if no match.
export function lensMatch(lens, q) {
  const s = String(q || '').trim().toLowerCase();
  if (!s || !lens) return null;
  for (const [k, label, skip] of FIELDS) {
    const v = lens[k];
    if (v && String(v).toLowerCase().includes(s)) return { field: label, value: String(v), skip: !!skip };
  }
  if (lens.category != null && lens.category !== '' &&
    (String(lens.category).toLowerCase().includes(s) || `cat.${lens.category}`.includes(s))) {
    return { field: 'category', value: `CAT.${lens.category}`, skip: false };
  }
  const fam = familyMeta(lens.family).label || '';
  if (fam.toLowerCase().includes(s)) return { field: 'family', value: fam, skip: false };
  return null;
}

// "Has photo" = a non-empty trimmed `lens_bank.photo_url`; NULL / '' / whitespace = no photo.
// The card renders the generated glass either way, so this is the ONE predicate the Photo filter
// reads — never test `photo_url` inline twice.
export function hasPhoto(lens) {
  return typeof lens?.photo_url === 'string' && lens.photo_url.trim() !== '';
}
